export function getOAuthParamsFromUrl(): Map<string, string > {
  const params = new URLSearchParams(window.location.search);
  const result = new Map<string, string>();
  
  for (const [key, value] of params.entries()) {
    result.set(key, value);
  }
     
  return result;
}

export class SeesionState {
	constructor(private readonly key: string) {
		
	}
	save(value: string){
		sessionStorage.setItem(this.key, value)
	}
	assert(value: string):boolean{
		return sessionStorage.getItem(this.key) === value
	}
	clean(){
		sessionStorage.clear()
	}
}